<template>
  <div>
    <announcement-viewer
      :include-participant="includeParticipants"
      :include-staff="includeStaff"
      :include-drafts="includeDrafts"
    />
  </div>
</template>

<script>
import AnnouncementViewer from '@/components/announcements/announcement-viewer.vue'

export default {
  name: 'Announcements',
  components: {
    AnnouncementViewer
  },
  data: function () {
    return {
      includeParticipants: false,
      includeStaff: false,
      includeDrafts: false
    }
  },
  created: function () {
    this.includeStaff = this.$root.courseScouterType === 'Staff'
    this.includeParticipant = this.$root.courseScouterType === 'Participant'
    // this.AnnouncementViewer.getData()
  }
}
</script>
